import Vue from "vue";
import { VDialog, VCard, VCardTitle, VCardText, VCardActions, VSpacer, VBtn } from "vuetify/lib";

Vue.component("v-dialog", VDialog);
Vue.component("v-card", VCard);
Vue.component("v-card-title", VCardTitle);
Vue.component("v-card-text", VCardText);
Vue.component("v-card-actions", VCardActions);
Vue.component("v-spacer", VSpacer);
Vue.component("v-btn", VBtn);

export default {};
